export default __webpack_public_path__ + "static/media/13_garden.ebb20655.png";